import { SidebarListFooterAction } from '../sidebar-list/sidebar-list.interfaces';

/** Minimal shape for items shown in the breadcrumb dropdown list. */
export interface BreadcrumbDropdownMenuItem {
  id?: string;
  label?: string;
  routerLink?: string | readonly (string | number)[];
  selected?: boolean;
}

export interface BreadcrumbDropdownItem {
  label: string;
  icon?: string;
  route: string;
  active?: boolean;
}

export interface BreadcrumbTruncate {
  /** Minimum width of the breadcrumb item label (e.g., '40px'). */
  minWidth?: string;
  /** Maximum width of the breadcrumb item label (e.g., '80px'). */
  maxWidth?: string;
}

export interface BreadcrumbItemData {
  isLastItem?: boolean;
  dropdown?: BreadcrumbDropdownItem[];
  originalItem?: BreadcrumbItem;
  /** Whether the item should be clickable/navigable. Defaults to true. */
  clickable?: boolean;
  icon?: string;
  /** Truncation constraints for this breadcrumb item. */
  truncate?: BreadcrumbTruncate;
  footerDropdownActions?: SidebarListFooterAction[];
}

export interface BreadcrumbItem {
  label?: string;
  icon?: string;
  routerLink: string;
  dropdown?: BreadcrumbDropdownItem[];
  isLast?: boolean;
  /** Whether the item should be clickable/navigable. Defaults to true. */
  clickable?: boolean;
  /** Truncation constraints for this breadcrumb item. */
  truncate?: BreadcrumbTruncate;
  footerDropdownActions?: SidebarListFooterAction[];
}

/**
 * Internal breadcrumb item shape used by the breadcrumb molecule.
 */
export interface BreadcrumbMenuItem {
  id?: string;
  label?: string;
  routerLink?: string | readonly (string | number)[];
  selected?: boolean;
  data?: BreadcrumbItemData;
}

export const BREADCRUMB_KEY = 'breadcrumb';

/**
 * Route data key to hide breadcrumb on a specific route.
 */
export const BREADCRUMB_HIDDEN_KEY = 'breadcrumb-hidden';

// Breadcrumb runtime logic has been moved to ui/molecules/breadcrumb/services.

export interface BreadcrumbRouteData {
  /** Display label (can be translation key or use :paramName for route params) */
  label?: string;
  /**
   * Icon identifier (for example a PrimeIcon name or SVG asset path).
   * If set without label, shows icon only.
   */
  icon?: string;
  /** If true, this route segment is hidden from breadcrumb */
  hidden?: boolean;

  /**
   * Whether the breadcrumb item should be clickable/navigable.
   * - `true` or `undefined`: item renders as a link (default behavior).
   * - `false`: item renders as plain text without navigation.
   */
  clickable?: boolean;

  /**
   * Dropdown options for this breadcrumb item.
   * When provided, the breadcrumb renders as a dropdown trigger.
   */
  dropdownOptions?: BreadcrumbDropdownItem[];

  footerDropdownActions?: SidebarListFooterAction[];

  /**
   * Truncation constraints for this breadcrumb item.
   * Controls how the item label truncates when space is limited.
   */
  truncate?: BreadcrumbTruncate;
}
